import { Component } from '@angular/core';
import { MatDialogRef } from '@angular/material/dialog';
import { AlertsType } from '@rappi/ui/alerts';

import { AlertsService } from '../../../../../services/alerts/alerts.service';
import { MakersFinancesMgrService } from '../../../../services/makers-finances-mgr.service';
import { SelectOption } from '../../../purchase-order-detail/sections/section-base.types';
import { FH_COMPANY_LABEL } from '../../company-form.constants';

export const COMPANY_GROUP_DIALOG_LABEL = {
  TITLE:       'Create company group',
  NAME_LABEL:  'Group name',
  CONFIRM:     'Create group',
  CREATED:     'Company group created.',
  FAILED:      'Could not create the company group. Please try again.',
  NAME_ERROR:  '*Required',
} as const;

// Inline creation behind the "Can't find a group? Create one" link under the Company group select.
// Resolves with the created option so the page can push it into the select and patch the control.
@Component({
  selector: 'app-company-group-dialog',
  templateUrl: './company-group-dialog.component.html',
  styleUrls: ['./company-group-dialog.component.scss'],
})
export class CompanyGroupDialogComponent {
  readonly LABELS = COMPANY_GROUP_DIALOG_LABEL;
  readonly COMMON = FH_COMPANY_LABEL;

  name = '';
  submitted = false;
  isSaving = false;

  constructor(
    public readonly dialogRef: MatDialogRef<CompanyGroupDialogComponent, SelectOption | null>,
    private readonly financesService: MakersFinancesMgrService,
    private readonly alerts: AlertsService,
  ) {}

  get hasNameError(): boolean {
    return this.submitted && !this.name.trim();
  }

  cancel(): void {
    this.dialogRef.close(null);
  }

  confirm(): void {
    this.submitted = true;
    const name = this.name.trim();
    if (!name || this.isSaving) {
      return;
    }

    this.isSaving = true;
    this.financesService.createCompanyGroup(name).subscribe({
      next: res => {
        this.isSaving = false;
        this.alerts.openAlerts(this.LABELS.CREATED, AlertsType.success);
        this.dialogRef.close({ id: String(res.data.id), name: res.data.name });
      },
      error: () => {
        this.isSaving = false;
        this.alerts.openAlerts(this.LABELS.FAILED, AlertsType.error);
      },
    });
  }
}
